import SetRoute from '../services/setRoute';

export const fetchImpactingPolicy = (fetch, params) => ({
    payload: {
        dataset: 'impacting_policy',
        action: 'get',
        route: SetRoute + `/api/v1/impacting_policies${params}`,
        data: {},
    },
    fetch,
});

export default fetchImpactingPolicy;
